import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { InboxLayoutManagerComponent } from './inbox-layout-manager.component';

@NgModule({
  declarations: [InboxLayoutManagerComponent],
  imports: [CommonModule, IonicModule, DragDropModule],
  exports: [InboxLayoutManagerComponent],
})
export class InboxLayoutManagerModule {}
